module.exports = __webpack_public_path__ + "img/i6.05517c52.svg";